module.exports = __webpack_public_path__ + "static/media/keeping-it-chill.07b0c75b.png";